'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import { useAppDispatch, useAppSelector } from '@/hook/redux-hooks';
import {
    setActiveImperfectionsCategory,
    setActiveImperfectionsImage,
    setInnerModalFlag,
    setInnerModalType,
} from '@/redux/reducers/gallery.reducer';
import { ImperfectionStatusEnum } from '@/types/imperfection-report.types';
import { ModalTypes } from '@/types/redux-state.types';
import { formatCamelCaseNames } from '@/utils';
// import { useWindowDimensions } from 'src/hooks';
import {
    ModalPropertyItem,
    ModalPropertyItemContainer,
    ModalPropertySectionContainer,
    ModalPropertyValueText,
    ModalPropertyWarningText,
    ModalSectionTitle,
    ModalTagContainer,
    ModalTagValue,
} from '../StyledComponents/modal-components';

export interface IProperties {
    name: string;
    value: string | React.ReactNode;
    comment?: string;
    type?: string;
    id?: string;
    status?: ImperfectionStatusEnum;
    tags?: string[];
    images?: string[] | null;
}

export interface IPropertyValueSection {
    title: string;
    properties: IProperties[];
}

const ModalPropertValueSection = ({
    data,
    valueType,
    applyGallery,
}: {
    data: IPropertyValueSection;
    valueType: 'text-with-comment' | 'text';
    applyGallery?: boolean;
}) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { imperfectionsImages } = useAppSelector(state => state.gallery);
    // const { width } = useWindowDimensions();
    // const lang = i18n.language;
    // const IS_RTL = lang === 'ar';
    // const isDesktop = width > 850;

    const onViewImagesClicked = (item: any) => {
        const { images } = item;
        const imageIndex = imperfectionsImages?.findIndex(
            (image: any) => image.original === images[0]
        );
        const category = imperfectionsImages[imageIndex].category;
        dispatch(setActiveImperfectionsCategory(category));
        dispatch(setActiveImperfectionsImage(imageIndex));
        dispatch(setInnerModalType(ModalTypes.Imperfections));
        dispatch(setInnerModalFlag(true));
    };
    const setPropertyValue = (propertyValue: string | number) => {
        if (propertyValue === 'Yes') {
            return t('Yes');
        }
        if (propertyValue === 'No') {
            return t('No');
        }
        return propertyValue;
    };
    const intiatePropertyValues = () => {
        const lastItemIndex = data.properties.length - 1;
        if (valueType === 'text') {
            const propertyValues = data.properties.map((item, index) => {
                return (
                    <ModalPropertyItemContainer
                        //@TODO ::  need to provide id from backend to use a valid key.
                        key={`${item.name}-${Math.random()}`}
                        style={{
                            borderBottom: index === lastItemIndex ? 'none' : '',
                        }}
                    >
                        {/*
              @eslint-disable-next-line @typescript-eslint/ban-ts-comment
            @ts-ignore */}
                        <ModalPropertyItem variant={'captionMedium'}>
                            {t(
                                formatCamelCaseNames(
                                    item.name
                                ) as unknown as TemplateStringsArray
                            )}
                        </ModalPropertyItem>
                        <ModalPropertyValueText variant={'caption'}>
                            {setPropertyValue(item.value as string)}
                        </ModalPropertyValueText>
                    </ModalPropertyItemContainer>
                );
            });
            return [...propertyValues];
        }
        const propertyValues = data.properties.map((item, index) => {
            return (
                <ModalPropertyItemContainer
                    key={item.name}
                    style={{
                        alignItems: 'flex-start',
                        borderBottom: index === lastItemIndex ? 'none' : '',
                    }}
                >
                    <div style={{ width: '90%' }}>
                        <ModalPropertyItem variant={'captionSemiBold'}>
                            {item.name}
                        </ModalPropertyItem>
                        {item.tags && item?.tags?.length > 0 && (
                            <ModalTagContainer>
                                {item.tags?.map(
                                    (tag, i) =>
                                        item?.status && (
                                            <ModalTagValue
                                                variant={'caption'}
                                                status={item?.status}
                                                key={
                                                    item.name +
                                                    '_' +
                                                    tag +
                                                    '_' +
                                                    i
                                                }
                                            >
                                                {tag}
                                            </ModalTagValue>
                                        )
                                )}
                            </ModalTagContainer>
                        )}
                        <ModalPropertyWarningText variant="caption">
                            {item?.comment}
                        </ModalPropertyWarningText>
                    </div>
                    {item.status !== ImperfectionStatusEnum.NotAvailable &&
                        item.images &&
                        applyGallery && (
                            <div
                                style={{ display: 'inline' }}
                                onClick={() => onViewImagesClicked(item)}
                            >
                                <Typography
                                    variant="caption"
                                    style={{
                                        color:
                                            item.status ===
                                            ImperfectionStatusEnum.Faulty
                                                ? '#B54708'
                                                : '#00673E',
                                        textDecoration: 'underline',
                                        whiteSpace: 'pre',
                                        marginInlineEnd: '8px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {t('View Image')}
                                </Typography>
                            </div>
                        )}
                    {item.value}
                </ModalPropertyItemContainer>
            );
        });
        return [...propertyValues];
    };
    return (
        <>
            <ModalSectionTitle variant="body2Medium">
                {data.title}
            </ModalSectionTitle>
            <ModalPropertySectionContainer>
                {intiatePropertyValues()}
            </ModalPropertySectionContainer>
        </>
    );
};
export default ModalPropertValueSection;
